// extracted by mini-css-extract-plugin
export default {"Icon":"styles_Icon__hjFiM","disabled":"styles_disabled__oq5h5"};